import terms from "../services/account.terms";

export default {
    namespaced: true,
    state: {
        loading: false,
        errors: null,
        termsAndCondition: "",
        termsOfUse: "",
        privacyPolicy: ""
    },
    mutations: {
        loading(state) {
            state.loading = true;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        termsAndCondition(state, value) {
            state.termsAndCondition = value;
        },
        termsOfUse(state, value) {
            state.termsOfUse = value;
        },
        privacyPolicy(state, value) {
            state.privacyPolicy = value;
        }
    },
    actions: {
        async getTermsAndCondition({ commit, state }) {
            commit("loading");
            try {
                let response = await terms.getTermsAndCondition();
                commit("termsAndCondition", response.terms_condition.replace(/^<div[^>]*>|<\/div>$/g, ''));
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async saveTermsAndCondition({ commit, state }, param) {
            commit("loading");
            try {
                let response = await terms.saveTermsAndCondition(param);
                commit("termsAndCondition", response.page.terms_condition);
                state.loading = false;
                //notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getTermsOfUse({ commit, state }) {
            commit("loading");
            try {
                let response = await terms.getTermsOfUse();
                commit("termsOfUse", response.terms_use.replace(/^<div[^>]*>|<\/div>$/g, ''));
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async saveTermsOfUse({ commit, state }, param) {
            commit("loading");
            try {
                let response = await terms.saveTermsOfUse(param);
                commit("termsOfUse", response.page.terms_use);
                state.loading = false;
                //notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async getPrivacyPolicy({ commit, state }) {
            commit("loading");
            try {
                let response = await terms.getPrivacyPolicy();
                // console.log(response.privacy_policy.replace(/^<div[^>]*>|<\/div>$/g, ''));
                commit("privacyPolicy", response.privacy_policy.replace(/^<div[^>]*>|<\/div>$/g, ''));
                state.loading = false;
            } catch (errors) {
                commit("errors", errors);
            }
        },
        async savePrivacyPolicy({ commit, state }, param) {
            commit("loading");
            try {
                let response = await terms.savePrivacyPolicy(param);
                commit("privacyPolicy", response.page.privacy_policy);
                state.loading = false;
                //notification.success(response.message);
            } catch (errors) {
                commit("errors", errors);
            }
        }
    }
};
